import { Link } from 'react-router'
import { getEnvColor, getEnvName, Mtds, TestTubeIcon } from 'prove-common'

export const AppLogo = () => {
  const envName = getEnvName()
  const envColor = getEnvColor(envName)
  return (
    <Mtds.Logo as={Link} to='/samples' data-env={envName} data-color={envColor}>
      <TestTubeIcon weight='fill' />
      Prøveplan
    </Mtds.Logo>
  )
}
